<div class="nav" id="navbar" [class.show-menu]="isShowMenu" (mouseleave)="hideSubMenu()">
    <div class="nav-head">
        <img src="assets/images/logos/ncp-new-logo.svg" />
    </div>
    <div class="accordion accordion-flush w-100" id="accordionExample">
        <ng-container *ngFor="let pages of loginPages; let i = index">
            <div class="accordion-item" routerLinkActive="active" *ngIf="(pages.PageGroup == pages.pageName)">
                <div class="accordion-header">
                    <button class="accordion-button no-sub" type="button"  [routerLink]="pages.PageURL">
                        <label for="group-{{i}}">
                            <i [innerHtml]="pages.PageIcon"></i>{{pages.pageName}}
                        </label>
                    </button>
                </div>
            </div>
            <div class="accordion-item accordion-has-submenu" routerLinkActive="active" *ngIf="(pages.PageGroup != pages.pageName)">
                <h2 class="accordion-header" id="headingOne">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse'+i" aria-expanded="true" aria-controls="collapseOne">
                        <label for="group-{{i}}">
                            <i [innerHtml]="pages.PageIcon"></i>{{pages.PageGroup}}
                        </label>
                    </button>
                </h2>
                <div id="collapse{{i}}" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                    <div class="accordion-body p-0">
                        <div class="list-group list-group-flush">
                            <a class="list-group-item list-group-item-action" routerLinkActive="active1" *ngFor="let page of pages.PageURL; let pageUrlIndex = index" routerLink="{{page}}">
                                <ng-container *ngFor="let pageName of pages.pageName;; let pageNameIndex = index">
                                    <ng-container *ngIf="pageNameIndex == pageUrlIndex">{{pageName}}</ng-container>
                                </ng-container>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>


    <!-- <div class="accordion accordion-flush w-100" id="accordionExample">
        <div class="accordion-item">
            <div class="accordion-header">
                <button class="accordion-button no-sub" type="button">
                    <i class="fas fa-tachometer-alt"></i> Dashboard
                </button>
            </div>
        </div>
        <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    <i class="fas fa-tools"></i> Masters
                </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div class="accordion-body p-0">
                    <div class="list-group list-group-flush">
                        <a  class="list-group-item list-group-item-action" aria-current="true">
                            The current link item
                        </a>
                        <a  class="list-group-item list-group-item-action">A second link item</a>
                        <a  class="list-group-item list-group-item-action">A third link item</a>
                        <a  class="list-group-item list-group-item-action">A fourth link item</a>
                        <a  class="list-group-item list-group-item-action">A disabled link item</a>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- <nav class="nav__container">
        <div class="nava">
            <ul class="nav__list">
                <li routerLinkActive="active" *ngFor="let pages of loginPages; let i = index"> 
                    <input id="group-{{i}}" type="checkbox" hidden />
                    <label for="group-{{i}}"  *ngIf="pages.PageURL.length <= 1"  [routerLink]="pages.PageURL"><i [innerHtml]="pages.PageIcon"></i>{{pages.PageGroup}} </label>
                    <label for="group-{{i}}"  *ngIf="pages.PageURL.length > 1"><i [innerHtml]="pages.PageIcon"></i>{{pages.PageGroup}} <span class="fa fa-angle-right"></span> </label>
                    <ng-container *ngIf="pages.PageURL.length > 1">
                    <ul class="group-list">
                            <li><a *ngFor="let page of pages.PageURL; let pageUrlIndex = index" routerLink="{{page}}">
                        <ng-container  *ngFor="let pageName of pages.pageName;; let pageNameIndex = index">
                            <ng-container  *ngIf="pageNameIndex == pageUrlIndex">{{pageName}}</ng-container>
                        </ng-container>
                        </a></li>
                    </ul>
                    </ng-container>
                </li>

            </ul>
        </div>
    </nav> -->
</div>